const initialState = {
  loading: false,
  usersList: null,        
  webUsersList: null,     
  kioskUsersList: null,   
  allUsersList: null,
  singleUser: null,
  subscriptionResult: null,
  subscriptionError: null,
  error: null,
};

export const usersReducer = (state = initialState, action) => {
  switch (action.type) {

    case "GET_USERS_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "GET_USERS_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        usersList: action.payload,
      };

    case "GET_WEB_USERS_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        webUsersList: action.payload,
      };

    case "GET_KIOSK_USERS_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        kioskUsersList: action.payload,
      };

    case "GET_USERS_LIST_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "GET_ALL_USERS_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "GET_ALL_USERS_SUCCESS":
      return {
        ...state,
        loading: false,
        allUsersList: action.payload,
      };

    case "GET_ALL_USERS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "GET_USER_REQUEST":
      return {
        ...state,
        loading: true,
        singleUser: null,
      };

    case "GET_USER_SUCCESS":
      return {
        ...state,
        loading: false,
        singleUser: action.payload,
      };

    case "GET_USER_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_USER_SUBSCRIPTION_REQUEST":
      return {
        ...state,
        loading: true,
        subscriptionError: null,
      };

    case "UPDATE_USER_SUBSCRIPTION_SUCCESS":
      return {
        ...state,
        loading: false,
        subscriptionResult: action.payload,
      };

    case "UPDATE_USER_SUBSCRIPTION_FAILED":
      return {
        ...state,
        loading: false,
        subscriptionError: action.payload,
      };

    default:
      return state;
  }
};
